import React from "react";
import { Drawer as DrawerPrimitive } from "vaul";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { DrawerCloseProps } from "../types";

function DrawerClose({ className, ...props }: DrawerCloseProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <DrawerPrimitive.Close
      data-slot="drawer-close"
      className={cn(className, classes)}
      {...native}
    />
  );
}

DrawerClose.displayName = "Drawer.Close";

export default DrawerClose;
